import { Component, EventEmitter, Output, Input, ViewChild, ViewContainerRef, ComponentFactoryResolver } from '@angular/core';
import { Events, ToastController, AlertController, NavParams } from 'ionic-angular';
import { DriveServiceProvider } from '../../providers/drive-service/drive-service';
import { StoreWrapProvider } from '../../providers/store-wrap/store-wrap';
import { ConfigApiServiceProvider } from '../../providers/config-api-service/config-api-service';

import { ConfigureServiceProvider } from '../../providers/configure-service/configure-service';
import { RuleEngineComponent } from '../rule-engine/rule-engine';


@Component({
  selector: 'rule-engine-setup',
  templateUrl: 'rule-engine-setup.html'
})


export class RuleEngineSetupComponent {
  @ViewChild('ruleEngineForm', { read: ViewContainerRef, static: false }) ruleEngineForm: ViewContainerRef;

  componentRef: any;
  showRulePage: boolean = false;
  showRulesetup: boolean = true;
  newRulearr: any = [];
  newRuleLength: any = 0;
  objCurrentFolderProperties: any = [];
  fields: any = [];
  @Input() params: any;
  @Output() clear_Component: EventEmitter<any> = new EventEmitter<any>();
  tempId: any;
  dropdownSettings = {};
  outputFields: any = [];
  folderId: any;
  folderName: any;
  ruleEdit: any = [];
  ruleCondition: any = [];
  ruleAction: any = [];
  ruleStage: any = [];
  ruleRunSchedule: any = [];
  editSummaryData: any = [];
  ruleID: any;
  activeRules: any = [];
  deleteIdx: any;
  reverse: boolean = false;
  arrTemplates: any = [];
  arrTemplateFields: any = [];
  WorkflowID: any;
  objAppCode: any;
  screen: any;
  allowRuleRun: boolean = false;
  ruleState: any = false;
  rulePostLength: any = 0;
  rulestatus: any;
  runRuleArray: any = [];

  constructor(public navParams: NavParams, public storeWrap: StoreWrapProvider, public events: Events, public alertctrl: AlertController, public driveService: DriveServiceProvider, public toastController: ToastController, public componentFactoryResolver: ComponentFactoryResolver, public configApiService: ConfigApiServiceProvider, public configureService: ConfigureServiceProvider) {
  }

  closeRulePage() {
    this.clear_Component.emit();
  }

  ngOnInit() {
    if (window.innerWidth > 700) {
      this.screen = "web";
    } else {
      this.screen = "Mobile";
    }
    this.getTemplates();
  }

  getTemplates() {
    this.storeWrap.storeTemplates
    Object.keys(this.storeWrap.storeTemplates).forEach(element => {
      this.arrTemplates.push(this.storeWrap.storeTemplates[element]);
    });
    this.getTemplateProperties();
  }

  getTemplateProperties() {
    this.tempId = this.params["template"][0]['id'];
    this.folderId = this.params["folder_id"];
    this.folderName = this.params["name"];
    this.getFields(this.tempId);
    this.getAllRules();
  }

  getFields(temp) {
    let data = temp
    let arrIdx = this.arrTemplates.findIndex(element => data === element["id"]);
    if (arrIdx != -1) {
      if (this.arrTemplates[arrIdx]["formLayout"]) {
        this.arrTemplateFields = this.arrTemplates[arrIdx]["formLayout"][0][0]["fields"];
        this.objAppCode = this.arrTemplates[arrIdx]["pullParams"]["client"];
      }
    }
    this.fields = { 'fields': this.arrTemplateFields, 'templateId': this.tempId, 'folderId': this.folderId, 'folderName': this.folderName };
  }

  getAllRules() {
    let folderId = this.params["folder_id"];
    if(this.driveService.objFolderRules[folderId] != undefined){
      let ruleData = this.driveService.objFolderRules[folderId];
      if(ruleData.length != 0){
        this.setRules(ruleData);
      }
    }else{
      let pullSummaryData = {
        "FolderInfo": this.folderId
      }
      var objData = Object.assign({}, this.configApiService.driveApi.SummaryAllRules.params, pullSummaryData, { "client": this.configureService.getStudio(), 'userid': this.configureService.getLoginUserID() })
      this.configApiService.pullRequest(objData, this.submitAllRules);
    }
  }

  submitAllRules = ((data) => {
    this.driveService.objFolderRules[this.folderId]= data;
    if (data['length'] != 0) {
      this.setRules(data);
    }
  })

  setRules(data){
    this.newRulearr = data;
    this.activateRunRuleState(this.newRulearr);
    this.newRuleLength = this.newRulearr.length - 1;
    this.WorkflowID = data[0]["WorkflowID"];
  }

  newRulePage(e) {
    this.showRulePage = true;
    this.editSummaryData = [];
    this.loadComponent();
  }


  runRule(e) {
    if (this.allowRuleRun == true) {
      this.activateRunRule();
    } else {
      const toast = this.toastController.create({
        message: 'Please, Enable any Rule to run',
        duration: this.configApiService.toastDuration,
        position: 'bottom'
      });
      toast.present();
    }
  }

  activateRunRule() {
    let obj = {
      "workflow": this.WorkflowID,
      "client": this.objAppCode
    }
    var objData = Object.assign({}, this.configApiService.driveApi.runRule.params, obj)
    this.configApiService.customRequest(this.configApiService.runRuleApi, objData, this.submitRunruleSucess)
  }

  submitRunruleSucess = ((resData) => {
    if (resData["_POST_RunWorkflowResult"] == "SUCCESS") {
      const toast = this.toastController.create({
        message: 'Rule Successfully Runned',
        duration: this.configApiService.toastDuration,
        position: 'bottom'
      });
      toast.present();
      return resData;
    }
  })

  //*** rule clone ***//
  defaultCloneString: any = '(Copy)'
  ruleClone(rule) {
    this.ruleID = rule.RuleID;
    let post_data = Object.assign({}, this.configApiService.driveApi.rulesClone.params, {
      "RuleID": rule.RuleID,
      "RuleName": rule.RuleName + this.defaultCloneString,
      "userid": this.configureService.getLoginUserID(),
      "client": this.configureService.getStudio()
    })
    this.configApiService.pushRequest(post_data, (respData) => {
      if (respData.EPC_BRE_Rules_Clone.NewRuleID) {
        var cloneStatusFalg = "clone"
        this.editRule(respData.EPC_BRE_Rules_Clone.NewRuleID, cloneStatusFalg);
      } else {
        const toast = this.toastController.create({
          message: 'Something getting Failed!',
          duration: this.configApiService.toastDuration,
          position: 'bottom'
        });
        toast.present();
      }
    });
  }

  submitSucess = ((result) => {
  })

  //**** RULE EDIT ****/
  editRule(ruleId, data) {
    this.rulestatus = data
    this.ruleID = ruleId
    let pullSummaryData = {
      "RuleID": ruleId
    }
    var SummaryRules = Object.assign({}, this.configApiService.driveApi.SummaryRules.params, pullSummaryData, { "client": this.configureService.getStudio(), 'userid': this.configureService.getLoginUserID() })
    this.configApiService.pullRequest(SummaryRules, this.submitSummerySucess);
  }

  submitSummerySucess = ((data) => {
    this.ruleEdit = data[0];
    let pullSummaryData = {
      "RuleID": this.ruleID
    }
    var SummaryCondition = Object.assign({}, this.configApiService.driveApi.SummaryCondition.params, pullSummaryData, { "client": this.configureService.getStudio(), 'userid': this.configureService.getLoginUserID() })
    this.configApiService.pullRequest(SummaryCondition, this.submitConditionSummerySucess);
  })

  submitConditionSummerySucess = ((data) => {
    this.ruleCondition = data;
    let pullSummaryData = {
      "RuleID": this.ruleID
    }
    var SummaryAction = Object.assign({}, this.configApiService.driveApi.SummaryAction.params, pullSummaryData, { "client": this.configureService.getStudio(), 'userid': this.configureService.getLoginUserID() })
    this.configApiService.pullRequest(SummaryAction, this.submitActionSummerySucess);
  })

  submitActionSummerySucess = ((data) => {
    this.ruleAction = data;
    let pullSummaryData = {
      "RuleID": this.ruleID
    }
    var SummaryStage = Object.assign({}, this.configApiService.driveApi.SummaryStage.params, pullSummaryData, { "client": this.configureService.getStudio(), 'userid': this.configureService.getLoginUserID() })
    this.configApiService.pullRequest(SummaryStage, this.submitStageSummerySucess);
  })

  submitStageSummerySucess = ((data) => {
    this.ruleStage = data;
    let pullSummaryData = {
      "RuleID": this.ruleID
    }
    var SummaryRunSchedule = Object.assign({}, this.configApiService.driveApi.pullmailschedule.params, pullSummaryData, { "client": this.configureService.getStudio(), 'userid': this.configureService.getLoginUserID() });
    this.configApiService.pullRequest(SummaryRunSchedule, this.submitScheduleSuccess);

  })

  submitScheduleSuccess = ((data) => {
    this.ruleRunSchedule = data;
    this.submitData();
  });

  submitData() {
    this.editSummaryData = [];
    this.showRulePage = true;
    this.editSummaryData.push({ 'ruleEdit': this.ruleEdit, 'ruleCondition': this.ruleCondition, 'ruleAction': this.ruleAction, 'ruleStage': this.ruleStage, 'ruleRunSchedule': this.ruleRunSchedule });

    this.loadComponent();
  }

  //**** RULE DELETE ****/

  deleteRule(ruleId, WorkflowID, idx) {
    this.deleteIdx = idx;
    this.ruleID = ruleId;
    this.WorkflowID = WorkflowID;
    let alert = this.alertctrl.create({
      title: 'Are you sure, want to delete?',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel'
        },
        {
          text: 'Ok',
          handler: data => {
            this.newRulearr.splice(this.deleteIdx, 1);
            this.newRuleLength = this.newRulearr.length - 1;
            this.postDeleteRule();
          }
        }
      ]
    });
    alert.present();
  }

  postDeleteRule() {
    let obj = {
      "RuleID": this.ruleID,
      "WorkflowID": this.WorkflowID
    }
    var objData = Object.assign({}, this.configApiService.driveApi.deleteRule.params, obj, { "client": this.configureService.getStudio() })
    this.configApiService.pushRequest(objData, (response) => {
      const toast = this.toastController.create({
        message: 'Rule Successfully Deleted',
        duration: this.configApiService.toastDuration,
        position: 'bottom'
      });
      toast.present();
    })
  }

  loadComponent() {
    if (this.showRulePage == true) {
      this.ruleEngineForm.clear();
      var data = {};
      for (var i = 0; i < Object.keys(this.storeWrap.storeTemplates[this.tempId].pullParams).length; i++) {
        if (Object.keys(this.storeWrap.storeTemplates[this.tempId].pullParams)[i] != 'start' && Object.keys(this.storeWrap.storeTemplates[this.tempId].pullParams)[i] != 'end') {
          data[Object.keys(this.storeWrap.storeTemplates[this.tempId].pullParams)[i]] = this.storeWrap.storeTemplates[this.tempId].pullParams[Object.keys(this.storeWrap.storeTemplates[this.tempId].pullParams)[i]];
        }
      }
      this.configApiService.fieldpropertyRequest(data, (_respData) => {
        let componentFactory = this.componentFactoryResolver.resolveComponentFactory(RuleEngineComponent);
        this.componentRef = this.ruleEngineForm.createComponent(componentFactory);
        this.componentRef.instance.rule_id = this.ruleID;
        this.componentRef.instance.rulestatusProperties = this.rulestatus;
        this.componentRef.instance.templatefields = this.fields;
        this.componentRef.instance.fieldProperties = _respData;
        this.componentRef.instance.edit_summary_data = this.editSummaryData;
        this.componentRef.instance.objCurrentFolderProperties = this.params;
        this.componentRef.instance.clearRulePageComponent.subscribe((data) => {
          if (data.status == 'postruleArr') {
            this.newRulearr = data.resData;
            this.driveService.objFolderRules[this.folderId]= this.newRulearr;
            this.activateRunRuleState(this.newRulearr);
            this.newRuleLength = this.newRulearr.length - 1;
            this.WorkflowID = this.newRulearr[0].WorkflowID;
            this.showRulePage = false;
          } else if (data.status == 'discard') {
            if (data.resData == true) {
              this.showRulePage = false;
              this.editSummaryData = [];
              this.getAllRules();
            }
          } else if (data.status == 'cloneRuleDiscard') {
            this.showRulePage = false;
            this.editSummaryData = [];
            this.postDeleteRule();
            this.getAllRules();
          }
        })
      })
    }
  }

  activateRunRuleState(newRulearr) {
    let idx = newRulearr.findIndex(e => e.Status == 2);
    if (idx > -1) {
      this.allowRuleRun = true;
    } else {
      this.allowRuleRun = false;
    }
  }
  runRuleSelected(e, rule) {
    let idx = this.newRulearr.findIndex(e => e.RuleID == rule.RuleID);
    if (idx != -1) {
      this.newRulearr[idx].Status = e.checked ? 2 : 1;
      this.runRuleArray.push(this.newRulearr[idx])
    }
    this.activateRunRuleState(this.newRulearr);

  }
  /***
   * Rule position change
   */
  rulePosition(id, position, index) {
    var Sortindex;
    if (position == 'up') {
      if (index != 0) {
        Sortindex = index - 1;

        let idx = this.newRulearr.findIndex(e => e.SortIdx == Sortindex)
        if (idx > -1) {
          this.newRulearr[idx].SortIdx = index;

        }
        this.newRulearr[index].SortIdx = Sortindex;
        this.newRulearr = this.arrayMove(this.newRulearr, index, Sortindex);

      }

    }

    if (position == 'down') {
      if (index != this.newRulearr.length - 1) {
        Sortindex = index + 1;

        let idx = this.newRulearr.findIndex(e => e.SortIdx == Sortindex)
        if (idx > -1) {
          this.newRulearr[idx].SortIdx = index;

        }
        this.newRulearr[index].SortIdx = Sortindex;
        this.newRulearr = this.arrayMove(this.newRulearr, index, Sortindex);

      }

    }
  }
  arrayMove(arr, old_index, new_index) {

    if (new_index >= arr.length) {
      var k = new_index - arr.length + 1;
      while (k--) {
        arr.push(undefined);
      }
    }
    arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
    return arr;
  };

  runRuleSave() {
    this.rulePostLength = 0;
    this.ruleState = false;
    this.runRuleArray.forEach((element, idx) => {
      var ele = element;
      delete ele["RowNumber"];
      let pushEnableStatus = {
        "action": "RuleEnableSort",
        "userid": this.configureService.getLoginUserID(),
        "client": this.configureService.getStudio()
      }
      var objData = Object.assign({}, this.configApiService.driveApi.runRuleEnable.params, element, pushEnableStatus)

      this.configApiService.pushRequest(objData, this.enableRuleSubmitSuccess);
    });
  }

  enableRuleSubmitSuccess = ((resdata) => {

    if ((this.newRulearr.length - 1) == this.rulePostLength) {
      this.ruleState = true;
    } else {
      this.ruleState = false;
      this.rulePostLength++;
      return;
    }
    if (this.ruleState) {
      if (resdata) {
        const toast = this.toastController.create({
          message: 'Rule Successfully Saved!',
          duration: this.configApiService.toastDuration,
          position: 'bottom'
        });
        toast.present();
      }
      this.runRuleArray = [];
    }
  })
}



// WEBPACK FOOTER //
// ./src/components/rule-engine-setup/rule-engine-setup.ts